import { getGlobalProperty } from "@faire/web/common/globals/getGlobalProperty";

export const NAVIGATION_TREE_HASH_CODE_PROPERTY_NAME = "navigationTreeHashCode";

/**
 * @deprecated Use `useNavigationTreeHashCode` instead.
 * @returns The navigation tree hashcode from the global property.
 */
export const getNavigationTreeHashCode = (): string | undefined =>
  getGlobalProperty<string>(NAVIGATION_TREE_HASH_CODE_PROPERTY_NAME);

export const useNavigationTreeHashCode = (): string | undefined => {
  return getNavigationTreeHashCode();
};
